module.exports = require("./UtilityBarItem.vue");